// The language codes that are used on the web and in crowdin are BCP 47 (best current practice)
// This merges language codes with country codes. We created a custom tag called es-la
// This is to represent all of Latin America and doesn't follow the BCP 47 standard
// Intl.DisplayNames doesn't have this custom BCP 47 tag so we have this code below to over ride
// es-LA Español(Laos) for Español (Latino América)
const correctedLocaleLabel: Record<string, string> = {
  'es-LA': 'Español (Latino América)',
};
export function getLanguageName(locale: string): string {
  let label;
  if (correctedLocaleLabel[locale]) {
    label = correctedLocaleLabel[locale];
  } else {
    const names = new Intl.DisplayNames([locale], {
      style: 'short',
      type: 'language',
    });
    label = names.of(locale) ?? locale;
  }

  return label;
}
